import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BaseRoutes } from '@nts/std';
import { environment } from 'src/environments/environment';

const title = environment ? environment.appTitle : 'Application Title';
const routes: Routes = [

    // #region rotte con autenticazione
    ...BaseRoutes.getBaseAuthentictedRoutes(
        environment,
        [
            // ...BaseRoutes.getEntityRoutes(
            //     title,
            //     'brand',
            //     () => import('./brand/brand.module').then(m => m.BrandModule)
            // ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'accountingcustomization',
                () => import('./accounting-customization/accounting-customization.module').then(m => m.AccountingCustomizationModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'accountingperiod',
                () => import('./accounting-period/accounting-period.module').then(m => m.AccountingPeriodModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'vatperiodicsettlement',
                () => import('./vat-periodic-settlement/vat-periodic-settlement.module').then(m => m.VatPeriodicSettlementModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'vattransfer',
                () => import('./vat-transfer/vat-transfer.module').then(m => m.VatTransferModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'stampduty',
                () => import('./stamp-duty/stamp-duty.module').then(m => m.StampDutyModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'payee',
                () => import('./payee/payee.module').then(m => m.PayeeModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'electronicinvoice',
                () => import('./electronic-invoice/electronic-invoice.module').then(m => m.ElectronicInvoiceModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'professionalfee',
                () => import('./professional-fee/professional-fee.module').then(m => m.ProfessionalFeeModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'professionalfeepayment',
                () => import('./professional-fee-payment/professional-fee-payment.module').then(m => m.ProfessionalFeePaymentModule)
            ),
            ...BaseRoutes.getDefaultRoutes(
                title,
                environment,
                true
            )
        ]
    ),
    // #endregion rotte con autenticazione

    // rotte base per la gestione degli errori
    ...BaseRoutes.getBaseErrorsRoute()

];

@NgModule({
    imports: [
        RouterModule.forRoot(routes),
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }
